import { create } from 'zustand';

/**
 * Counter bumped whenever the local user submits a chat intent
 * (typed message, slash command, action). Chat surfaces listen for
 * the increment and force-scroll to the bottom + re-arm auto-follow
 * so the player's own message lands in view even if they had been
 * reading history.
 *
 * Mirrors the mobile `chatScrollKickProvider`. Counter (vs. boolean
 * with reset) avoids missed-edge races when multiple sends queue.
 */
interface ChatScrollKickState {
  kick: number;
  bump: () => void;
}

export const useChatScrollKickStore = create<ChatScrollKickState>((set) => ({
  kick: 0,
  bump: () => set((s) => ({ kick: s.kick + 1 })),
}));
